import { module } from 'modujs';
import { roundRandom, random } from '../utils/maths';
import { gsap } from 'gsap';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.loading(10);
    }

    loading(loadingKisses) {
        html.classList.add('has-dom-ready');

        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        
        for (let index = 0; index <= loadingKisses; index++) {

            let $kiss = document.createElement('span');
            $kiss.classList.add('c-kiss');
            // $kiss.classList.add('-big');
            let width = roundRandom(50,100);
    
            $kiss.style.top = `${(random(0,this.windowHeight - $kiss.getBoundingClientRect().width))}px`;
            $kiss.style.left = `${random(0, this.windowWidth - $kiss.getBoundingClientRect().width)}px`;
            $kiss.style.transform=`rotate(${random(-45, 45)}deg)`;
    
            gsap.delayedCall((0.3 * index+1), () => {
                this.el.append($kiss);
    
                let tl = gsap.timeline();
                tl.fromTo($kiss,{
                    scale: 0,
                    alpha: 0
                },{
                    scale: 1,
                    alpha: 1,
                    duration: 0.4
                });
                tl.to($kiss,{
                    scale: 0,
                    alpha: 0,
                    duration: 0.4,
                    delay: 0.5
                });
    
                gsap.delayedCall(1.8, () => {
                    $kiss.parentNode.removeChild($kiss);
                });

                if(index == loadingKisses - 1) {
                    gsap.delayedCall(1,() => {
                        html.classList.add('has-dom-ready-pre-callback');
            
                        gsap.delayedCall(0.3,() => {
                            html.classList.add('has-dom-ready-callback');
                        });
                    });
                }
            });
        }

    }
}
